import { render, staticRenderFns } from "./ProductCategoryCreate.vue?vue&type=template&id=3d5c6ff3&scoped=true"
import script from "./ProductCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryCreate.vue?vue&type=style&index=0&id=3d5c6ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c6ff3",
  null
  
)

export default component.exports